import React from 'react';
import { DisabledPrompt, useModel } from "@bcm-dev/bcms-vite";
import { SVGAsset } from 'res';
import { getScheduledDescription } from '../..';

/**
 * @function MobileScheduledWireTableRow
 * @return {React.Component}
 * @exported false
 * @description The row that shows in the Mobile Scheduled Wires Table
 */

export function MobileScheduledWireTableRow(props) {
  const { branding } = useModel() ?? {};
  const { options } = branding ?? {};
  const hasNotifyPayeeColumn = options.scheduled_wires_notify_payee_abi22 === "true";
  const scheduledWire = props.scheduledWire ?? {};
  const notifyPayee = scheduledWire.notifyPayee ? "Yes" : "No";
  let status = scheduledWire.statusDescription;

  // Capitalize first letter of each word.
  status = status.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ');
  if (status === "Pending Approval") {
    status = "Pending FI Approval";
  }
    const scheduledDescription = getScheduledDescription(scheduledWire);
  return (
    <div className="mobile-scheduled-wire-row flex-container flex-horizontal align-center space-between">
      <div className="wire-details-column flex-width">
        <div className="flex-container flex-horizontal space-between wires-item">
          <b className="flex-item set-width">{scheduledWire.referenceNumber? `#${scheduledWire.referenceNumber}` : ''}</b>
          <p className="set-item flex-width text-right">{scheduledWire.amount.format()}</p>
        </div>

   
        <div className="flex-container flex-horizontal space-between wires-item">
          <p className="flex-item flex-width">Next Wire Date:</p>
          <p className="set-item flex-width text-right">{scheduledWire.futureWireDate.format('m/d/Y')}</p>
        </div>
        <div className="flex-container flex-horizontal space-between wires-item status">
          <p className="flex-item flex-width">Scheduled:</p>
          <p className="set-item flex-width text-right">{scheduledDescription}</p>
        </div>
      </div>
      <DisabledPrompt><SVGAsset id="MagnifyingGlassIcon" className="inline-text-icon left-icon clickable set-width" /></DisabledPrompt>
            <DisabledPrompt><SVGAsset id="TrashcanXIcon" className="inline-text-icon left-icon clickable set-width" /></DisabledPrompt>
    </div>
  );
}